import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import ArticleView from "@/components/public/ArticleView";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/articles/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="pt-40 text-center min-h-screen">
      <h1 className="font-serif text-4xl mb-4">Artículo no encontrado</h1>
      <Link to="/articulos" className="kicker text-sunset-accent">Volver a artículos</Link>
    </div>
  );
  if (!article) return <div className="pt-40 text-center min-h-screen text-sunset-muted">Cargando…</div>;

  return (
    <div data-testid="article-detail">
      <SEO
        title={article.seo_title || article.title}
        description={article.meta_description || article.excerpt}
        image={article.og_image || article.cover_image}
        type="article"
        article={article}
      />
      <ArticleView article={article} />
    </div>
  );
}
